module.exports = __webpack_public_path__ + "static/media/email.1e68f46d.svg";